import { render, staticRenderFns } from "./DynamicTable.vue?vue&type=template&id=70224c84&scoped=true"
import script from "./DynamicTable.vue?vue&type=script&lang=js"
export * from "./DynamicTable.vue?vue&type=script&lang=js"
import style0 from "./DynamicTable.vue?vue&type=style&index=0&id=70224c84&prod&lang=scss&scoped=true"
import style1 from "./DynamicTable.vue?vue&type=style&index=1&id=70224c84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70224c84",
  null
  
)

export default component.exports